module.exports = __webpack_public_path__ + "img/arm.af03b015.jpg";